import React from 'react';
import CustomNavbar from './CustomNavbar';
import Footer from './Footer';
import ParticlesBackground from './ParticlesBackground';

const Layout = ({ children }) => {
    return (
        <div className="d-flex flex-column min-vh-100 position-relative">
            <ParticlesBackground />
            <div className="d-flex flex-column flex-grow-1" style={{ position: 'relative', zIndex: 1 }}>
                <CustomNavbar />
                <main className="flex-grow-1">
                    {children}
                </main>
                <Footer />
            </div>
        </div>
    );
};

export default Layout;
